// extracted by mini-css-extract-plugin
module.exports = {"container":"VolumentalWidget_container__EYfZ_","description":"VolumentalWidget_description__HPkYR"};